var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: { hover: true }
        }
      ],
      staticClass: "project_on_hold",
      attrs: { id: "deliverable__type__icon", title: _vm.deliverableType }
    },
    [
      _c("div", { staticClass: "media-call-icon pointer-default" }, [
        _c("img", {
          attrs: { src: require("@/csmworkflow/img/project-on-hold-icon.svg") }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }